module.exports = __webpack_public_path__ + "static/media/shuffle.16a1d5e6.svg";